import { render, staticRenderFns } from "./contextDocuments.vue?vue&type=template&id=0e68deef&"
import script from "./contextDocuments.vue?vue&type=script&lang=js&"
export * from "./contextDocuments.vue?vue&type=script&lang=js&"
import style0 from "./contextDocuments.vue?vue&type=style&index=0&id=0e68deef&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports